// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"FlashCardContent_cardContent__cPRbt"};